import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { DialogService } from 'primeng/api';
import { NewPropertyActivityComponent } from '../new-property-activity/new-property-activity.component';
import { RecentlyCompletedTasksComponent } from '../../tasks/recently-completed-tasks/recently-completed-tasks.component';
import { PropertyService } from './../property.service';

@Component ({
  selector: 'app-quick-search',
  templateUrl: './quick-search.component.html',
  styleUrls: ['./quick-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService]
})

export class QuickSearchComponent implements OnInit {

  NewPropertiesDialog = false;
  RecentlyCompletedTasksDialog = false;

  constructor(private dialogService: DialogService, private propertyService: PropertyService) {}

  ngOnInit() {}

  displayNewPropertiesDialog(display: boolean): void {
    this.dialogService.open(NewPropertyActivityComponent, {});
  }

  displayRecentlyCompletedTasksDialog(display: boolean): void {
    this.dialogService.open(RecentlyCompletedTasksComponent, {});
  }

  getFavoritePropertiesSearchUri(): string {
    return this.propertyService.getFavoritePropertiesSearchUri();
  }

}
